import { render, staticRenderFns } from "./ManageSitesGroup.vue?vue&type=template&id=0e45a1ac&scoped=true"
import script from "./ManageSitesGroup.vue?vue&type=script&lang=js"
export * from "./ManageSitesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e45a1ac",
  null
  
)

export default component.exports